import { CloudArrowDownIcon } from "@heroicons/react/24/outline";
import CiroSpinner from "../../shared/CiroSpinner";
import CiroButton from "../../shared/CiroButton";
import useHandleDownloadAutopilotContacts from "../../../reactHooks/autopilotList/contactList/useHandleDownloadAutopilotContacts";
import classNames from "classnames";

const AutopilotSessionDownloadButton = ({
  autopilotSessionId,
  autopilotSessionName,
  contactIds,
}: {
  autopilotSessionId: number;
  autopilotSessionName: string | null;
  contactIds: number[];
}) => {
  const { handleDownloadContacts, isDownloading } =
    useHandleDownloadAutopilotContacts();

  return (
    <CiroButton
      analyticsField="Download Autopilot Session Contacts"
      analyticsProps={{ autopilotSessionId }}
      disabled={isDownloading}
      onClick={() =>
        handleDownloadContacts({
          autopilotSessionId,
          autopilotSessionName: autopilotSessionName ?? undefined,
          customContactIds: contactIds,
        })
      }
    >
      {isDownloading ? (
        <CiroSpinner loading={true} />
      ) : (
        <>
          <CloudArrowDownIcon className={classNames("w-5", "h-5")} />
          <span className={classNames("ml-1")}>
            {Boolean(contactIds?.length) && `${contactIds?.length}`}
          </span>
        </>
      )}
    </CiroButton>
  );
};

export default AutopilotSessionDownloadButton;
